// extracted by mini-css-extract-plugin
export default {"link_box":"index_link_box_--MWU","box":"index_box_1bk2e clearfix"};